<template>
  <el-menu-item
    class="submenu-title-noDropdown"
    @click="generateFeedbackReport"
    :disabled="isGenerating"
  >
    <Item
      icon="messages"
      :title="isGenerating ? 'Генерируется...' : 'Обратная связь'"
    />
  </el-menu-item>
</template>

<script>
import { mapGetters } from "vuex";
import { postFeedback } from "@/api/feedback";
import { Message } from "element-ui";
import Item from "@/layout/components/Sidebar/Item";

export default {
  name: "FeedbackButton",
  components: {
    Item,
  },
  data() {
    return {
      isGenerating: false,
    };
  },
  computed: {
    ...mapGetters(["mediaUrl"]),
  },
  methods: {
    async generateFeedbackReport() {
      if (this.isGenerating) return;

      this.isGenerating = true;

      try {
        const response = await postFeedback({});
        const { path } = response;

        if (path) {
          const url = `${this.mediaUrl}/${path}`;

          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          // Поведение: Firefox требует добавления в DOM для некоторых версий
          document.body.appendChild(a);
          a.click();
          a.remove();

          Message({
            message: "Отчет успешно сгенерирован",
            type: "success",
            duration: 5000,
          });
        }
      } catch (error) {
        console.error("Error generating feedback report:", error);
        Message({
          message: "Ошибка при генерации отчета",
          type: "error",
          duration: 5000,
        });
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>
